import urql, {
  createClient,
  // dedupExchange,
  fetchExchange,
  subscriptionExchange,
  Client,
} from '@urql/vue'

import { devtoolsExchange } from '@urql/devtools'
import { CacheExchange } from './cache'
import { AuthErrorExchange, AuthExchange } from './auth'
import { createClient as createWSClient } from 'graphql-ws'

export default defineNuxtPlugin((nuxt) => {
  const { vueApp } = nuxt

  const getWebSocketUrl = (httpUrl: string) => {
    try {
      const url = new URL(httpUrl)
      const wsUrl = `${url.protocol === 'https:' ? 'wss:' : 'ws:'}//${
        url.host
      }${url.pathname}`
      console.log('Parsed WebSocket URL:', wsUrl)
      return wsUrl
    } catch (error) {
      console.error('Error parsing GraphQL URL:', error)
      throw error
    }
  }

  const wsClient = createWSClient({
    url: getWebSocketUrl(nuxt.$config.public.gqlHost),
  })

  const SubscriptionExchange = subscriptionExchange({
    forwardSubscription(request) {
      const input = { ...request, query: request.query || '' }
      console.log('Forwarding subscription:', input) // Log subscription request
      return {
        subscribe(sink) {
          const unsubscribe = wsClient.subscribe(input, sink)
          return { unsubscribe }
        },
      }
    },
  })

  wsClient.on('error', (error) => {
    console.error('WebSocket error:', error)
  })

  const client = createClient({
    url: nuxt.$config.public.gqlHost,
    requestPolicy: 'cache-and-network',
    exchanges: [
      devtoolsExchange,
      // dedupExchange,
      CacheExchange,
      AuthErrorExchange,
      AuthExchange,
      fetchExchange,
      SubscriptionExchange,
    ],
    maskTypename: true,
  })

  nuxt.provide('urql', client)
  vueApp.provide('$urql', ref(client))
})

declare module '#app' {
  interface NuxtApp {
    $urql: Client
  }
}
